module.exports = __webpack_public_path__ + "img/dna.3c4f119f.svg";